import styled from 'styled-components';

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width || '100%'};
  max-width: ${(props) => props.maxWidth || 'none'};
  min-width: 0;
  box-sizing: border-box;

  /* Prevent children from expanding beyond container */
  > label,
  > select,
  > div {
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.theme.name === 'dark' ? '#E5E7EB' : '#4B5563')};
`;

export const Required = styled.span`
  color: #ef4444;
`;

export const StyledSelect = styled.select`
  width: 100%;
  padding: 12px 14px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#ffffff'};
  border: 1px solid
    ${(props) => {
      if (props.error) return '#ef4444';
      return props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.15)';
    }};
  border-radius: 6px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#1F2937')};
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%239CA3AF' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 18px;
  padding-right: 48px;

  &:focus {
    border-color: ${(props) =>
      props.error ? '#ef4444' : props.theme?.colors?.primary || '#fa4616'};
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.error ? 'rgba(239, 68, 68, 0.1)' : 'rgba(250, 70, 22, 0.1)'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Fix autofill background color in dark theme */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px
      ${(props) =>
        props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#ffffff'}
      inset !important;
    -webkit-text-fill-color: ${(props) =>
      props.theme.name === 'dark' ? '#ffffff' : '#1F2937'} !important;
    transition: background-color 5000s ease-in-out 0s;
  }

  option {
    background: ${(props) =>
      props.theme.name === 'dark' ? '#1F2937' : '#ffffff'};
    color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#1F2937')};
  }
`;

export const HelperText = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: ${(props) => (props.error ? '#ef4444' : '#64748B')};
`;
